import { ImisResponseItemsRaw } from "../models/imis.models";
import { RestUtility } from "./rest.utility";

async function getGroupMemberByCompanyUserId(companyId: string, userId: string): Promise<ImisResponseItemsRaw> {
    let groupMemberResponse = await RestUtility.restApiGetData<ImisResponseItemsRaw>("/api/groupmember", { GroupId: `ORGRELATIONSHIP-${companyId}`, PartyId: userId }, true);
    if (groupMemberResponse == null) {
        throw new Error(`Existing group member record could not be retrieved for companyId: ${companyId} and userId: ${userId}`);
    }

    return groupMemberResponse;
}

async function isUserCompanyAdminByCompanyUserId(companyId: string, userId: string): Promise<boolean> {
    let isCompanyAdmin = false;
    
    let groupMemberResponse = await getGroupMemberByCompanyUserId(companyId, userId);
    if (groupMemberResponse.Items.$values.length > 0) {
        // ensure user is already a active company admin, and update if not
        let groupMember = groupMemberResponse.Items.$values[0];
        let companyAdminMembershipDetail = getCompanyAdminGroupMemberDetailsFromGroupMember(groupMember);
        if (companyAdminMembershipDetail != null && companyAdminMembershipDetail.IsActive) {
            isCompanyAdmin = true;
        }
    } 

    return isCompanyAdmin;
}

async function setUserAsCompanyAdminByCompanyUserId(companyId: string, userId: string): Promise<void> {
    let payload = getCreateGroupMemberPayload(companyId, userId);
    addRoleToGroupMemberPayload(payload, "COMPANYADMINISTRATOR");
    
    let groupMemberResponse = await getGroupMemberByCompanyUserId(companyId, userId);
    if (groupMemberResponse.Items.$values.length > 0) {
        let existingPayload = groupMemberResponse.Items.$values[0];
        let companyAdminMembershipDetail = getCompanyAdminGroupMemberDetailsFromGroupMember(existingPayload);
        if (companyAdminMembershipDetail != null) {
            // the group member detail is probably not active, update it
            companyAdminMembershipDetail.IsActive = true;
        } else {
            // the group member detail is not found, create it
            existingPayload.MembershipDetails.$values.push(payload.MembershipDetails.$values[0]);
        }

        payload = existingPayload;
    }

    let createUpdateResponse = await RestUtility.restApiSendData("/api/groupmember", payload);
    if (createUpdateResponse == null) {
        throw new Error(`Group member record could not be created/updated for companyId: ${companyId} and userId: ${userId}`);
    }
}

function addRoleToGroupMemberPayload(payload: any, roleId: string) {
    payload.MembershipDetails.$values.push({
        "$type": "Asi.Soa.Membership.DataContracts.OrganizationGroupMemberDetailData, Asi.Contracts",
        "IsActive": true,
        "Role": {
            "$type": "Asi.Soa.Membership.DataContracts.GroupRoleData, Asi.Contracts",
            "RoleId": roleId
        }
    });
}

function getCreateGroupMemberPayload(companyId: string, userId: string) {
    return {
        "$type": "Asi.Soa.Membership.DataContracts.GroupMemberData, Asi.Contracts",
        "MembershipDetails": {
            "$type": "Asi.Soa.Membership.DataContracts.GroupMemberDetailDataCollection, Asi.Contracts",
            "$values": []
        },
        "Group": {
            "$type": "Asi.Soa.Membership.DataContracts.GroupSummaryData, Asi.Contracts",
            "GroupId": "ORGRELATIONSHIP-" + companyId,
        },
        "Party": {
            "$type": "Asi.Soa.Membership.DataContracts.PartySummaryData, Asi.Contracts",
            "PartyId": userId,
        },
        "IsActive": true
    };
}

function getCompanyAdminGroupMemberDetailsFromGroupMember(groupMemberRecord: any) {
    let companyAdminMembershipDetail = groupMemberRecord.MembershipDetails.$values.find(detail => detail.Role.RoleId == "COMPANYADMINISTRATOR");
    return companyAdminMembershipDetail;
}

export {
    getGroupMemberByCompanyUserId,
    isUserCompanyAdminByCompanyUserId,
    setUserAsCompanyAdminByCompanyUserId,
    getCreateGroupMemberPayload,
    addRoleToGroupMemberPayload,
    getCompanyAdminGroupMemberDetailsFromGroupMember
};